import { SafeResourceUrl } from "@angular/platform-browser";
import { BlogStatus } from "../../enums/blog-status-enum";
import { BaseModel } from "../base.model";
import { UserBaseModel } from "../members/user/user-base.model";
import { EntityFileUploadModel } from "../file/entity-file-upload-model";

export class BlogsBaseModel extends BaseModel {
    createdBy?: UserBaseModel;
    categories: string[] =[];
    tags: string[] = [];
    title: string = "";
    description: string | undefined = undefined;
    blogText: string = "";
    isPublic: boolean = false;
    status?: BlogStatus = BlogStatus.Draft;
    coverPhotoFileId: string| undefined;
    displayCoverPhotoFile: SafeResourceUrl| undefined;
    revision?: string;
    publishDate?: Date | undefined;
    attachedFilesIds?: string[] = [];
    createdByName?: string | undefined;

    override fileUpload: EntityFileUploadModel = new EntityFileUploadModel();
}
